import Link from 'next/link';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

type CampusMapLinkTileProps = {
  href: string;
  label: string;
  className?: string;
};

/** Prominent map handoff shared by Campus overview and transit. */
export function CampusMapLinkTile({ href, label, className = '' }: CampusMapLinkTileProps) {
  return <Link
    href={href}
    className={`group relative inline-flex aspect-square w-36 shrink-0 items-end overflow-hidden rounded-feature border border-line bg-surface-subtle text-left shadow-e1 outline-none hover:shadow-e2 focus-visible:ring-2 focus-visible:ring-focus focus-visible:ring-offset-2 focus-visible:ring-offset-surface sm:w-40 ${className}`}
    aria-label={label}
  >
    <span
      className="absolute inset-0 bg-cover bg-right"
      style={{ backgroundImage: "url('/campus/map-preview.webp')", backgroundSize: '210% 130%', backgroundPosition: 'right 100%' }}
      aria-hidden="true"
    />
    <span className="relative flex min-h-12 w-full items-center justify-between gap-2 bg-[var(--ss-text)] px-3 py-2 text-sm font-semibold leading-5 text-[var(--ss-surface)]">
      <span>{label}</span><ArrowTopRightOnSquareIcon className="h-4 w-4 shrink-0" aria-hidden="true" />
    </span>
  </Link>;
}
